import { gql } from '@apollo/client';

export const GET_CASHFLOW_SCENARIOS = gql`
  query CashflowScenarios(
    $portfolioId: String!
    $asOfDate: String!
    $scenario1Name: String!
    $scenario2Name: String!
    $scenario3Name: String!
    $freqType: String!
    $skip: Int
    $take: Int
  ) {
    cashflowScenarios(
      portfolioId: $portfolioId
      asOfDate: $asOfDate
      scenario1Name: $scenario1Name
      scenario2Name: $scenario2Name
      scenario3Name: $scenario3Name
      freqType: $freqType
      skip: $skip
      take: $take
    ) {
      scenario
      cashflows {
        recId
        portfolioId
        asOfDate
        freqType
        scenario
        scenarioName
        cfPeriod
        apmRptSecClass
        secClass
        secClassLongDesc
        secClassShortDesc
        scenarioSortOrder
        secClassSortOrder
        reportRGB
        reportHex
        totalPrincipal
        totalInterest
        totalPandI
        positionCount
        wtdAvgProjectedYield
        lastUpdatedDate
        lastUpdatedBy
        institutionName
        institutionCity
        institutionState
      }
    }
  }
`;
